export default "__VITE_ASSET__CtPyl09h__"